import React from 'react';
import { Styles } from './styles';

export function LayoutContentListItem({ allSectionsHidden, children, fullWidth, fullHeight, inSlider, ...props }) {
    return (
        <Styles
            $allSectionsHidden={allSectionsHidden}
            $fullWidth={fullWidth}
            $fullHeight={fullHeight}
            $inSlider={inSlider}
            {...props}
        >
            {children}
        </Styles>
    );
}
